import React from 'react';
import { accent } from '../utils/colors';
import SkillLevelSelect from './SkillLevelSelect';

export default function SkillRow({ skill, grades, onChangeSkillLevel }) {
  return (
    <tr key={skill.skillId}>
      <td style={{ position: 'sticky', left: 0, background: '#fff', padding: '8px 12px', borderBottom: '1px solid #f7f3ff', maxWidth: 420 }} title={skill.description}>
        <a href={`#/skill/${skill.skillId}`} style={{ color: accent, textDecoration: 'none' }}>{skill.skillName}</a>
        {skill.learningStatusDescription && (
          <span style={{ marginLeft: 8, color: '#888' }}>
            [{skill.learningStatusDescription}]
          </span>
        )}
      </td>
      {grades.map(g => {
        const gradeFlag = skill.gradeFlags.find(flag => String(flag.gradeId) === g.id);
        const checked = gradeFlag ? gradeFlag.isChecked : false;
        const currentLevel = gradeFlag && gradeFlag.skillLevel != null ? gradeFlag.skillLevel : '';
        return (
          <td key={g.id} style={{ padding: '8px 12px', borderBottom: '1px solid #f7f3ff', textAlign: 'center' }}>
            <SkillLevelSelect
              value={checked ? String(currentLevel) : ''}
              onChange={(e) => onChangeSkillLevel(skill.skillId, gradeFlag.gradeId, e.target.value)}
              style={{ padding: '4px 6px' }}
            />
          </td>
        );
      })}
    </tr>
  );
}


